import { FC, useState, useEffect, MutableRefObject, useImperativeHandle } from 'react';
import { Switch } from 'antd';
import InstaModalDrawer from '@/components/InstaModalDrawer';
import { toggleGlobalScroll } from '@/utils';
import { useMobx } from '@/hooks/useMobx';
import styles from './DNSModal.module.less';

interface IProps {
  // showDNSModal: boolean;
  // setShowDNSModal: Dispatch<SetStateAction<boolean>>;
  modalRef: MutableRefObject<{ showModal: () => void }>;
}

const DNSModal: FC<IProps> = ({ modalRef }) => {
  const {
    app: { isMobile, CookieConsentInstance },
    area: { LANG },
  } = useMobx(['app', 'area']);
  const [showDNSModal, setShowDNSModal] = useState(false);
  const [allowSelling, setAllowSelling] = useState(true);
  // setAllowSelling(CookieConsentInstance?.consent?.statistics && CookieConsentInstance?.consent?.marketing);

  const showModal = () => {
    setShowDNSModal(true);
    toggleGlobalScroll(true);
  };

  const handleCloseModal = () => {
    setShowDNSModal(false);
    toggleGlobalScroll(false);
  };

  const handleConfirmChoice = () => {
    const preferences = CookieConsentInstance?.consent?.preferences;
    CookieConsentInstance.handleSubmitCustomConsent(!!preferences, allowSelling, allowSelling, true);
    handleCloseModal();
  };

  useEffect(() => {
    const statistics = CookieConsentInstance?.consent?.statistics;
    const marketing = CookieConsentInstance?.consent?.marketing;
    setAllowSelling(statistics && marketing);
  }, [CookieConsentInstance?.consent, showDNSModal]);

  useImperativeHandle(modalRef, () => ({
    showModal,
  }));

  return (
    // @ts-expect-error InstaModalDrawer
    <InstaModalDrawer
      destroyOnClose
      closable={false}
      zIndex={1005}
      open={showDNSModal}
      width={640}
      wrapClassName={isMobile ? styles.DNSModalMobile : styles.DNSModal}
      // onCancel={handleCloseModal}
    >
      <div className={styles.header}>
        <div className={styles.title}>{LANG['common.cookieConsent.DNSModal.title']}</div>
        <div style={{ cursor: 'pointer' }} onClick={handleCloseModal}>
          <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path
              d='M5.03412 5.03412C5.36606 4.70217 5.90425 4.70217 6.2362 5.03412L18.9654 17.7633C19.2973 18.0952 19.2973 18.6334 18.9654 18.9654C18.6334 19.2973 18.0952 19.2973 17.7633 18.9654L5.03412 6.2362C4.70217 5.90425 4.70217 5.36606 5.03412 5.03412Z'
              fill='#B6B6C0'
            />
            <path
              d='M18.9659 5.03412C18.6339 4.70217 18.0957 4.70217 17.7638 5.03412L5.03464 17.7633C4.70269 18.0952 4.70269 18.6334 5.03464 18.9654C5.36658 19.2973 5.90477 19.2973 6.23672 18.9654L18.9659 6.2362C19.2978 5.90425 19.2978 5.36606 18.9659 5.03412Z'
              fill='#B6B6C0'
            />
          </svg>
        </div>
      </div>
      <div className={styles.content}>
        <div dangerouslySetInnerHTML={{ __html: LANG['common.cookieConsent.DNSModal.content1'] }} />
        <div className={styles.control}>
          <div>{LANG['common.cookieConsent.DNSModal.selling']}</div>
          <Switch className={styles.switch} checked={allowSelling} onChange={(value) => setAllowSelling(value)} />
        </div>
        <div dangerouslySetInnerHTML={{ __html: LANG['common.cookieConsent.DNSModal.content2'] }} />
      </div>
      <div className={styles.confirm}>
        <div className={styles.btn} onClick={handleConfirmChoice}>
          {LANG['common.cookieConsent.DNSModal.confirm']}
        </div>
      </div>
    </InstaModalDrawer>
  );
};

export default DNSModal;
